import React, { useState } from 'react';
import { acceptReadPhishingTerm, getReadPhishingTerm } from 'utils/session';

export default function PhishingAlert() {
  const [showAlert, setShowAlert] = useState(!getReadPhishingTerm());

  if (!showAlert) {
    return null;
  }

  return (
    <div
      className={
        'border rounded-lg mx-2 mb-1 px-3 py-2 bg-brand-red-main/10 relative flex items-center justify-between'
      }
    >
      <p className={'text-xs text-brand-black'}>
        <b>Security Alert!</b> 🚨 Beware of phishing links! Ensure URLs are legitimate and secure before proceeding.
        Never share personal info on suspicious sites. Think before you click to protect your data.
      </p>

      <button
        className={'text-sm font-semibold text-brand-black ml-2 px-2 py-1 rounded bg-white/80 hover:bg-white'}
        onClick={() => {
          setShowAlert(false);
          acceptReadPhishingTerm();
        }}
      >
        OK
      </button>
    </div>
  );
}
